export default __webpack_public_path__ + "static/media/notification.5e01b960.wav";